<template>
    <section class="section" style="padding-top:0;">
      <div class="container content">
        <div class="columns is-multiline">
          <div class="column is-12 has-text-centered">
            <h1 class="title is-size-3 is-size-4-mobile script primary is-spaced has-text-left-mobile">{{ view.content.headline }}</h1>
            <p class="subtitle is-size-4 is-size-6-mobile has-text-left-mobile" v-if="view.content.subtitle.length">{{ view.content.subtitle }}</p>
          </div>
          <div class="column is-8">

             <!-- swiper -->
            <swiper :options="swiperOption" v-if="view.content.images.length">
              <swiper-slide v-for="(i, index) in view.content.images" :key="'s' + index" :style="'background-image: url(' + assetsBaseUrl + i.path + ');'"><div class="caption" v-if="i.caption.length || i.credits.length"><p class="is-size-7-mobile" style="line-height:normal;">{{ i.caption }}<br v-if="i.credits.length"><span class="is-size-7" v-if="i.credits.length">© {{ i.credits }}</span></p></div></swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>










            <span v-html="view.content.text" class="is-size-6 is-size-7-mobile"></span>

          </div>
          <div class="column is-4" id="sidebar">

            <!-- masonry images -->
            <div v-masonry transition-duration="0s" item-selector=".item" v-if="view.content.masonry.length" class="columns is-multiline">
              <div v-masonry-tile class="column is-6 item" v-for="(i, index) in view.content.masonry">
                <img :src="assetsBaseUrl + i.path" @click="$emit('showLightbox', i.path)" class="cursor">
              </div>
            </div>

            <a v-if="view.content.downloads.length" target="_blank" :href="assetsBaseUrl + i.url" class="button is-primary is-rounded is-fullwidth button-align-left" style="margin-bottom: 0.5rem;" v-for="(i, index) in view.content.downloads" :key="index">
              <span class="icon is-small"><i class="fa fa-download"></i></span><span>{{ i.caption }}</span>
            </a>

            <a  v-if="view.content.links.length" target="_blank" :href="i.url" class="button is-light is-rounded is-fullwidth button-align-left" style="margin-bottom: 0.5rem;" v-for="(i, index) in view.content.links" :key="'l' + index">
              <span class="icon is-small"><i class="fa fa-chain"></i></span><span>{{ i.caption }}</span>
            </a>

            <div class="box primary has-text-weight-bold" v-if="view.content.sidebar.length"><vue-markdown>{{ view.content.sidebar }}</vue-markdown></div>

            <div v-if="view.content.videos.length" class="videowrapper" v-for="(i, index) in view.content.videos" :key="'v' + i">
              <iframe width="560" height="315" :src="'https://www.youtube-nocookie.com/embed/' + i" frameborder="0" allowfullscreen></iframe>
            </div>

          </div>

        </div>
      </div>
    </section>
</template>

<script>
import VueMarkdown from 'vue-markdown-v2'
export default {
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  props: ['view'],
  computed: {
    assetsBaseUrl () {
      return this.$store.getters.assetsBaseUrl
    }
  },
  components: {
    VueMarkdown
  }
}
</script>

<style scoped>
  .swiper-container {
    background-color: #000;
    height: 300px;
    margin-bottom: 30px;
  }
  .gallery-top {
    height: 400px;
    width: 100%;
  }
  .gallery-thumbs {
    height: 20% !important;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100px;
    opacity: 0.4;
  }
  .gallery-thumbs .swiper-slide-active {
    opacity: 1;
  }

@media screen and (min-width: 1024px) {
  .swiper-container {
  width: 100% !important;
  height: 500px;
}
}

  .swiper-container .swiper-slide {
    background-position: center;
    background-size: cover;
  }
  .box {
    margin-top:30px;
  }
  .uc {
    text-transform: uppercase;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/Project.vue